import moment from "moment";
import { Priority } from "@app/shared/components/que-mnger-expand-config/priority";
import { QueuedJobStatus } from "./que-mnger-expand-config.component";

export class QueDataSort {
  private _dataSource: any[];

  column: string;
  asc: boolean;

  sort() {
    if (this._dataSource && this.column) {
      this._dataSource = this._dataSource.slice().sort((a: any, b: any) => this.compare(a, b));
    }
    return this._dataSource;
  }

  set dataSource(dataSource: any[]) {
    this._dataSource = dataSource.slice();
  }

  compare(a: any, b: any) {
    switch (this.column) {
      case 'priority':
        let c = Priority[b.priority]
        b = Priority[a.priority]
        a = c
        break;
      case 'status':
        a = QueuedJobStatus[a.status];
        b = QueuedJobStatus[b.status];
        break;
      default:
        if (this.column.match('Time')) {
          [a, b] = this.compareTime(a, b);
        } else {
          a = a[this.column]
          b = b[this.column]
        }
    }

    if (a == b) {
      return 0;
    }
    else {
      return ((a < b ? -1 : 1) * (this.asc ? 1 : -1))
    };
  }

  compareStatus(a: any, b: any) {
    return [
      a.status == 'queued' ? 1 : 0,
      b.status == 'queued' ? 1 : 0
    ]
  }

  compareTime(a: any, b: any) {
    let aTime = moment(a[this.column]).toDate().getTime();
    let bTime = moment(b[this.column]).toDate().getTime();

    if (aTime == bTime) {
      return this.compareStatus(a, b)
    } else {
      return [aTime, bTime]
    }
  }
}
